
import React from "react";
import Layout from "../components/Layout";
import ContactForm from "../components/ContactForm";

const ContactPage: React.FC = () => {
  return (
    <Layout>
      <div className="bg-gradient-to-b from-techne-primaryPurple/10 to-transparent">
        <div className="container-custom pt-12 pb-16">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-techne-primaryPurple mb-4">
              Contact Us
            </h1>
            <p className="text-xl text-gray-600">
              Have questions about AI governance or need assistance? Reach out to our team.
            </p>
          </div>
          
          <div className="bg-white rounded-xl shadow-lg overflow-hidden max-w-4xl mx-auto">
            <div className="gradient-bg text-white p-8 text-center">
              <h2 className="text-2xl font-bold mb-2">Send Us a Message</h2>
              <p>Fill out the form below and we'll get back to you soon</p>
            </div>
            
            <div className="p-8">
              <ContactForm 
                leadListName="BoardSight Inquiry"
                className="shadow-none p-0" 
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ContactPage;
